import { createInitialStates, createResourceNames, createSequenceTypes, getErrorData } from '../helpers'
import { INITIAL_STATE_REDUCERS, RECORD_COUNT_HEADER } from '../constants'

const RESOURCES = [
  'chargesByCustomerIdGet',
  'chargesByIdEventsGet',
  'chargesByIdGet',
  'chargesByIdLabelGet',
  'chargebackByIdGet'
]
const R = createResourceNames(RESOURCES)
const TYPES = createSequenceTypes([
  'CHARGES_BY_CUSTOMER_ID_GET',
  'CHARGES_BY_ID_EVENTS_GET',
  'CHARGES_BY_ID_GET',
  'CHARGES_BY_ID_LABEL_GET',
  'CHARGES_WITH_CHARGEBACK_GET',
  'CHARGEBACK_BY_ID_GET'
])
export const INITIAL_STATE = {
  ...createInitialStates(RESOURCES, INITIAL_STATE_REDUCERS)
}

const reducers = {
  // CHARGES BY ID GET .................................................................................................
  [TYPES.CHARGES_BY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.chargesByIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.CHARGES_BY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.chargesByIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.CHARGES_BY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.chargesByIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.CHARGES_BY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.chargesByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // CHARGES BY ID EVENTS GET ........................................................................................
  [TYPES.CHARGES_BY_ID_EVENTS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.chargesByIdEventsGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.CHARGES_BY_ID_EVENTS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.chargesByIdEventsGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.CHARGES_BY_ID_EVENTS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.chargesByIdEventsGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.CHARGES_BY_ID_EVENTS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.chargesByIdEventsGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // CHARGES BY ID LABEL GET .........................................................................................
  [TYPES.CHARGES_BY_ID_LABEL_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.chargesByIdLabelGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.CHARGES_BY_ID_LABEL_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.chargesByIdLabelGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.CHARGES_BY_ID_LABEL_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.chargesByIdLabelGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.CHARGES_BY_ID_LABEL_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.chargesByIdLabelGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // CHARGES BY CUSTOMER ID GET V2......................................................................................
  [TYPES.CHARGEBACK_BY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.chargebackByIdGet]: { data: {}, error: {}, isLoading: true }
    }
  },
  [TYPES.CHARGEBACK_BY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.chargebackByIdGet]: { data }
    }
  },
  [TYPES.CHARGEBACK_BY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.chargebackByIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.CHARGEBACK_BY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.chargebackByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // CHARGES BY CUSTOMER ID GET ........................................................................................
  [TYPES.CHARGES_BY_CUSTOMER_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.chargesByCustomerIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.CHARGES_BY_CUSTOMER_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ responseStatus: payload.status, ...payload.data }]
    return {
      ...state,
      [R.chargesByCustomerIdGet]: { data, error: {}, isLoading: false, total: payload.headers[RECORD_COUNT_HEADER] }
    }
  },
  [TYPES.CHARGES_BY_CUSTOMER_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.chargesByCustomerIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.CHARGES_BY_CUSTOMER_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.chargesByCustomerIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  }
}

export default reducers
